import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { ControlContainer, FormsModule, NgForm } from '@angular/forms';
import { FormService } from '../../../common/services/form.service';
import { Field } from 'src/sb-tools/typescript/models/field.model';
import { ClientField } from '../../../common/models/client-field.model';
import { FieldPossibleValue } from '@sb-tools/typescript/models/field-possible-value.model';
import { NgClass } from '@angular/common';
import { FormFieldLabelComponent } from '@form-field-module/common/components/form-field-label/form-field-label.component';

@Component({
    selector: 'sb-checklist',
    templateUrl: './checklist.component.html',
    styleUrls: ['./checklist.component.scss'],
    viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
    imports: [NgClass, FormsModule, FormFieldLabelComponent],
})
export class ChecklistComponent implements OnInit, OnChanges {
    @Input() formField: Field | ClientField;

    placeholder: string;
    values: FieldPossibleValue[];

    constructor(
        public formService: FormService,
        private ngForm: NgForm,
    ) {}

    ngOnInit() {
        this.formField.valueModel = [];

        if (this.formField.value) {
            this.initPreselectedValues();
            this.change();
        }
    }

    ngOnChanges() {
        this.formField.valueModel = [];
    }

    change() {
        this.formField.valueModel = this.formField.possibleValues
            .filter((value) => {
                return value.isChecked;
            })
            .map((value) => {
                return value.value;
            });

        if (this.formField.valueModel.length) {
            this.formField.value = this.formField.valueModel.join(', ');
        } else {
            this.formField.value = '';
        }
        // trigger form values changes
        this.ngForm.form.updateValueAndValidity({ onlySelf: false, emitEvent: true });
    }

    private initPreselectedValues(): void {
        const valuesList = this.formField.value.split(', ');

        this.formField.possibleValues.forEach((possibleValue) => {
            if (
                valuesList.find((selectedValue) => {
                    return selectedValue === possibleValue.value;
                })
            ) {
                possibleValue.isChecked = true;
            }
        });
    }
}
